import { render, staticRenderFns } from "./QuizBragCorrectRate.vue?vue&type=template&id=2caabcde&scoped=true&"
import script from "./QuizBragCorrectRate.vue?vue&type=script&lang=js&"
export * from "./QuizBragCorrectRate.vue?vue&type=script&lang=js&"
import style0 from "./QuizBragCorrectRate.vue?vue&type=style&index=0&id=2caabcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caabcde",
  null
  
)

export default component.exports